import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import successAnimation from 'assets/lottie/success.json';
import { Ptag } from './fonts';

const SuccessModal = ({ isOpen, onClose, message = "Selections Saved!" }) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: successAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // Auto close after 2 seconds

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
         
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '540px',
          height: '200px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        }}
      >
        <div
          style={{
            width: '80px',
            height: '80px',
            marginBottom: '1rem',
          }}
        >
          <Lottie
            options={defaultOptions}
            height={64}
            width={64}
            isClickToPauseDisabled
          />
        </div>
       <Ptag
          style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#333',
            textAlign: 'center',
          }}
        >
          {message}
        </Ptag>
      </div>
    </div>
  );
};

export default SuccessModal;
